<div class="p-3 mt-1 card border rounded">
  <div class="mb-3 border-bottom border-secondary-subtle">
    <div class="d-flex justify-content-between">
      <div>
        <p class="p-0 m-0 text-dark fw-bolder fs-22">
          {{ 'CONTRACT.DEPOSIT' | translate }}
        </p>
        <p class="p-0 m-0 text-dark text-muted">
          {{ 'CONTRACT.DEPOSIT_DESC' | translate }}
        </p>
      </div>
      <div class="text-md-end">
        <button (click)="onEdit()" class="btn btn-primary btn-sm cursor-pointer">
          <i class="las la-edit"></i>{{ 'CONTRACT.EDIT' | translate }}
        </button>
      </div>
    </div>
  </div>
  @if(data()?.depositType != null) {
    <div class="d-flex flex-column gap-3">
      <div class="row">
        <div class="col-lg-6">
          <p class="p-0 m-0 fw-bold fs-5">
            {{ 'CONTRACT.DEPOSIT_TYPE' | translate }}
          </p>
          <p class="p-0 m-0 text-muted">
            {{ "APARTMENT.DEPOSIT_TYPE." + data()?.depositType | translate }}
          </p>
        </div>
      </div>
      @if(data()?.depositType != DepositType.NO_DEPOSIT) {
        <div class="d-flex flex-wrap gap-4">
          <div>
            <p class="p-0 m-0 fw-bold fs-5">
              {{ 'CONTRACT.DEPOSIT_AMOUNT' | translate }}
            </p>
            <p class="p-0 m-0 text-muted">
              {{ data()?.depositAmount | moneyFormat }}
            </p>
          </div>
          <div>
            <p class="p-0 m-0 fw-bold fs-5">
              {{ 'CONTRACT.DEPOSIT_DUE_DATE' | translate }}
            </p>
            <p class="p-0 m-0 text-muted">
              {{ data()?.depositDueDate | localizedDate:'dd/MM/yyyy' }}
            </p>
          </div>
        </div>
        <div>
          <p class="p-0 m-0 fw-bold fs-5">
            {{ 'CONTRACT.DEPOSIT_PAYMENT' | translate }}
          </p>
          <p class="p-0 m-0 text-muted">
            {{ ('APARTMENT.DEPOSIT_PAYMENT.' + data()?.depositPayment) | translate }}
          </p>
        </div>
      }
    </div>
  }
</div>
